import React from 'react';

const Article = ({ short_description, slug, thumbnail, title }) => {
  return (
    <a href={`/tin-tuc/${slug}`} style={{ color: '#333333' }}>
      <article className='flex'>
        <img src={thumbnail} width='250px' height='150px' alt='' />
        <div className='content'>
          <h3
            style={{
              display: '-webkit-box',
              height: '55px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: '3',
            }}
          >
            {title}
          </h3>
          <p
            style={{
              display: '-webkit-box',
              height: '100px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: '4',
            }}
          >
            {short_description}
          </p>
        </div>
      </article>
    </a>
  );
};
export default Article;
